import { useMutation } from "@tanstack/react-query";
import { requestURLs } from "../../Environment";
import { z } from "zod";
import {
  AxiosResponseAndError,
  ResponseType,
} from "@/api/types/axiosResponseType";
import ApiRequest from "../ApiRequest";
import { reAssginedTaskSchema } from "@backend/src/schemas/organisationSchema";

type ReAssgingTaskApiResponse = ResponseType<null>;

function useReAssgingTasktoMemberMutation() {
  const mutation = useMutation<
    AxiosResponseAndError<ReAssgingTaskApiResponse>["response"],
    AxiosResponseAndError<ReAssgingTaskApiResponse>["error"],
    z.infer<typeof reAssginedTaskSchema> & {projectId?:string}
  >({
    mutationFn: (data) =>
      ApiRequest.put<ReAssgingTaskApiResponse>(`${requestURLs.task}reAssignTaskToOtherUser/${data.projectId}`, data),
  });

  return mutation;
}
export default useReAssgingTasktoMemberMutation;